import { Navigate } from 'react-router-dom';
import { PageBody } from '@/components/layout/page-header';
import { EstadoIndisponivel } from '@/components/patterns/states';
import { Skeleton } from '@/components/ui/skeleton';
import type { Funcionalidade } from '@/data/types';
import { useAcesso, usePodeVer } from '@/hooks/use-acesso';
import { useSessao } from '@/hooks/use-sessao';
import { tabsVisiveis } from '@/navigation';

function CarregandoRota() {
  return (
    <PageBody>
      <div className="flex flex-col gap-4" role="status" aria-label="Verificando o seu acesso">
        <Skeleton className="h-16 w-80 max-w-full rounded-card" />
        <Skeleton className="h-12 rounded-card" />
        <Skeleton className="h-64 rounded-card" />
      </div>
    </PageBody>
  );
}

/**
 * Guarda de rota de funcionalidade: skeleton enquanto o acesso carrega, a tela
 * quando há acesso, e um estado claro (sem redirecionar mudo) quando não há.
 */
export function RotaFuncionalidade({
  funcionalidade,
  children,
}: {
  funcionalidade: Funcionalidade;
  children: React.ReactNode;
}) {
  const { carregando } = useAcesso();
  const { rolesCarregando } = useSessao();
  const pode = usePodeVer(funcionalidade);
  if (carregando || rolesCarregando) return <CarregandoRota />;
  if (!pode) {
    return (
      <PageBody>
        <EstadoIndisponivel />
      </PageBody>
    );
  }
  return <>{children}</>;
}

/** `/`: vai para o primeiro tab disponível; sem nenhum, explica. */
export function Inicio() {
  const { acesso, carregando } = useAcesso();
  const { rolesCarregando } = useSessao();
  if (carregando || rolesCarregando) return <CarregandoRota />;
  const primeiro = tabsVisiveis(acesso)[0];
  if (primeiro) return <Navigate to={primeiro.rota} replace />;
  return (
    <PageBody>
      <EstadoIndisponivel
        titulo="Nenhuma área disponível para o seu perfil"
        descricao="No momento o Compilações não tem nenhuma área liberada para você. Fale com quem administra para pedir acesso."
      />
    </PageBody>
  );
}
